import { Skeleton } from 'components/ui/skeleton';

interface TableSkeletonProps {
	rows?: number;
	columns?: number;
	className?: string;
}

export const TableSkeleton = ({
	rows = 10,
	columns = 8,
	className = '',
}: TableSkeletonProps) => {
	return (
		<div
			className={`tw-w-full tw-bg-white tw-border tw-border-solid tw-border-[#e2e5e7] tw-rounded-lg ${className}`}
		>
			{/* Header Skeleton */}
			<div className='tw-flex tw-border-b tw-border-solid tw-border-[#e2e5e7]'>
				{Array.from({ length: columns }, (_, index) => (
					<div
						key={`header-${index}`}
						className='tw-flex-1 tw-min-w-[100px] tw-p-3 tw-border-r tw-border-solid  tw-border-[#e2e5e7] last:tw-border-r-0'
					>
						<Skeleton className='tw-h-[40px] tw-w-full tw-bg-gray-300' />
					</div>
				))}
			</div>

			{/* Rows Skeleton */}
			{Array.from({ length: rows }, (_, rowIndex) => (
				<div
					key={`row-${rowIndex}`}
					className={`tw-flex tw-hover:tw-bg-[#f5f5f5] ${
						rowIndex !== rows - 1
							? 'tw-border-b tw-border-solid tw-border-[#e2e5e7]'
							: ''
					}`}
				>
					{Array.from({ length: columns }, (_, colIndex) => (
						<div
							key={`cell-${rowIndex}-${colIndex}`}
							className='tw-flex-1 tw-min-w-[100px] tw-p-3 tw-border-r tw-border-solid tw-border-[#e2e5e7] last:tw-border-r-0'
						>
							<Skeleton className='tw-h-[20px] tw-w-full tw-bg-gray-300' />
						</div>
					))}
				</div>
			))}
		</div>
	);
};
